class DateError extends Error {
  constructor(message) {
    super(message);
    this.name = "DateError";
  }
}

export default DateError;